import React from "react";
import {
  TitleWrap,
  SecTitle,
  SecSubTitle,
  FeatureBoxTwo,
} from "../../components/";
import Slider from "react-slick";

const FeatureTwo = ({ className }) => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={`feature-wrap2 ${className || ""}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 col-xxl-3 text-center text-xxl-start">
            <TitleWrap>
              <SecSubTitle>
                <i className="fas fa-bring-forward" />
                Why Choose Us
              </SecSubTitle>
              <SecTitle className="h1 text-capitalize">
                Why People Choose Our Services
              </SecTitle>
            </TitleWrap>
          </div>
          <div className="col-xxl-9">
            <Slider className="row feature-slide2" {...settings}>
              <FeatureBoxTwo
                title="ERP & Enterprise Solutions"
                image="images/icon/fe-2-1.png"
                text="Scalable ERP and enterprise-grade solutions to streamline and integrate your business operations."
                path="/services/erp-enterprise-solutions"
              />
              <FeatureBoxTwo
                title="Custom Software Solutions"
                image="images/icon/fe-2-2.png"
                text="Tailor-made software solutions designed to match your unique workflows and goals."
                path="/services/custom-software-solutions"
              />
              <FeatureBoxTwo
                title="Web Development"
                image="images/icon/fe-2-3.png"
                text="Modern, responsive websites built with performance, usability, and SEO in mind."
                path="/services/web-development"
              />
              <FeatureBoxTwo
                title="Web Applications"
                image="images/icon/fe-2-4.png"
                text="Dynamic, secure, and scalable web applications accessible anytime, anywhere."
                path="/services/web-applications"
              />
              <FeatureBoxTwo
                title="Mobile & App Development"
                image="images/icon/fe-2-1.png"
                text="High-performing mobile apps for iOS, Android, and cross-platform solutions."
                path="/services/mobile-app-development"
              />
              <FeatureBoxTwo
                title="IT Consulting"
                image="images/icon/fe-2-2.png"
                text="Expert consulting to align IT strategies with business objectives."
                path="/services/it-consulting"
              />
              <FeatureBoxTwo
                title="Managed IT Services"
                image="images/icon/fe-2-3.png"
                text="Comprehensive IT management including monitoring, support, and security."
                path="/services/managed-it-services"
              />
              <FeatureBoxTwo
                title="SAP Solutions & Support"
                image="images/icon/fe-2-4.png"
                text="End-to-end SAP solutions and ongoing support to optimize business processes."
                path="/services/sap-solutions-support"
              />
            </Slider>

            {/* <Slider className="row feature-slide2" {...settings}>
              <FeatureBoxTwo 
                title="IT Solution"
                image="images/icon/fe-2-1.png"
                text="Seize magnetic before visa alignment network wireless whereas frictionless"
                path="/service-details"
              />
              <FeatureBoxTwo 
                title="IT Consultant"
                image="images/icon/fe-2-2.png"
                text="Seize magnetic before visa alignment network wireless whereas frictionless"
                path="/service-details"
              />
              <FeatureBoxTwo 
                title="Cyber Security"
                image="images/icon/fe-2-3.png"
                text="Seize magnetic before visa alignment network wireless whereas frictionless"
                path="/service-details"
              />
              <FeatureBoxTwo 
                title="App Development"
                image="images/icon/fe-2-4.png"
                text="Seize magnetic before visa alignment network wireless whereas frictionless"
                path="/service-details"
              />
            </Slider> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureTwo;
